import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';

// Page Dialogs
import { PAGEDIALOG_CONTACT, PAGEDIALOG_OBJEKTANFRAGE, PAGEDIALOG_SATISFACTION, PAGEDIALOG_SUCHPROFIL, PAGEDIALOG_SUCHPROFILLIST } from '../constants'; // Import your dialog constants
import PageDialogContactForm from './Dialogs/PageDialogContactForm';
import PageDialogCookie from './Dialogs/PageDialogCookie';
import PageDialogLogin from './Dialogs/PageDialogLogin';
import PageDialogObjectRequestForm from './Dialogs/PageDialogObjectRequestForm';
import PageDialogRegister from './Dialogs/PageDialogRegister';
import PageDialogSatisfaction from './Dialogs/PageDialogSatisfaction';
import PageDialogSearchProfileForm from './Dialogs/PageDialogSearchProfileForm';
import PageDialogSearchprofilesList from './Dialogs/PageDialogSearchprofilesList';

function SiteWrapper() {
  let activeMobileMenu = useSelector((state) => state.app.mobileMenuOpen);
  const pageDialogOpenId = useSelector((state) => state.app.pageDialogOpenId);
  const loginFormPageDialogOpen = useSelector((state) => state.loginForm.pageDialogOpen);
  const registerFormPageDialogOpen = useSelector((state) => state.registerForm.pageDialogOpen);

  const renderActiveDialog = () => {
    if (!pageDialogOpenId) return null;

    switch (pageDialogOpenId) {
      case PAGEDIALOG_SUCHPROFILLIST:
        return <PageDialogSearchprofilesList />;
      case PAGEDIALOG_CONTACT:
        return <PageDialogContactForm />;
      case PAGEDIALOG_SUCHPROFIL:
        return <PageDialogSearchProfileForm />;
      case PAGEDIALOG_OBJEKTANFRAGE:
        return <PageDialogObjectRequestForm />;
      case PAGEDIALOG_SATISFACTION:
        return <PageDialogSatisfaction />;
      default:
        return null;
    }
  };

  return (
    <div id="sreal-kundenportal-root" className={activeMobileMenu ? 'no-scroll is-blurred' : ''}>
      {loginFormPageDialogOpen && <PageDialogLogin />}
      {registerFormPageDialogOpen && <PageDialogRegister />}

      <PageDialogCookie />

      {renderActiveDialog()}
      <Outlet />
      <Footer />
    </div>
  );
}

export default SiteWrapper;
